(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["little-nook-personalisation"] && !Shopify.designMode) return;
  try {
    (() => {
    function initialiseLittleNookPersonalisation(root = document) {
      root.querySelectorAll('.little-nook-personalisation').forEach((wrapper) => {
        if (wrapper.dataset.initialised === 'true') return;

        const form = document.getElementById(wrapper.dataset.formId);
        if (!form) return;

        wrapper.dataset.initialised = 'true';

        form.addEventListener(
          'submit',
          (event) => {
            const invalidField = wrapper.querySelector(':invalid');
            if (!invalidField) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            invalidField.reportValidity();
            invalidField.focus();
          },
          true
        );
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseLittleNookPersonalisation(), { once: true });
    } else {
      initialiseLittleNookPersonalisation();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseLittleNookPersonalisation(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
